<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!isPeriodoSelecionado"
                            @change="loadFrom('demandaTipo')"
                            :options="form.tiposDemanda"
                            default-option-text="Todos"
                            label="Tipo de Demanda"
                            show-default-option
                            text-field="text"
                            v-model="model.demandaTipo"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableEspecialidade"
                            :options="form.especialidades"
                            @change="loadFrom('especialidade')"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuario"
                            :options="form.usuarios"
                            @change="loadFrom('usuario')"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableProcedimento"
                            :options="form.procedimentos"
                            default-option-text="Todos"
                            label="Procedimentos SIGTAP"
                            show-default-option
                            text-field="descricao"
                            v-model="model.procedimentoCodigo"
                            value-field="codigo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableProcedimentoAbpg"
                            :options="form.procedimentosAbpg"
                            default-option-text="Todos"
                            label="Procedimentos ABPG"
                            show-default-option
                            text-field="nome"
                            v-model="model.procedimentoAbpgId"
                            value-field="id"
                        >
                            <template v-slot:label-trailing>
                                <rkm-icon
                                    icon="info-circle"
                                    title="ABPG corresponde ao procedimento registrado na produção da Atenção Básica. Quando houver ABPG sem procedimento SIGTAP vinculado, o relatório exibirá o ABPG e manterá o SIGTAP sem vínculo correspondente."
                                    v-rkm-tooltip.hover
                                />
                            </template>
                        </rkm-form-select>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />

                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                <rkm-icon icon="print" />

                </rkm-button>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportar"
                    color="info"
                    small
                    title="Exportar para XLS"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
            <rkm-table
                :fields="fields"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
            >
                <template #cell(pacienteDataNascimento)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(pacienteIdade)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(cbo)="{ item }">
                    {{ cboText(item) }}
                </template>

                <template #cell(especialidadeNome)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(usuarioNome)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(procedimentosSigtap)="{ value }">
                    {{ value && value.length ? value.join(', ') : '-' }}
                </template>

                <template #cell(procedimentosSigtapDescricao)="{ value }">
                    {{ value && value.length ? value.join(', ') : '-' }}
                </template>

                <template #cell(procedimentosAbpg)="{ value }">
                    {{ value && value.length ? value.join(', ') : '-' }}
                </template>

                <template #cell(procedimentosAbpgDescricao)="{ value }">
                    {{ value && value.length ? value.join(', ') : '-' }}
                </template>
                    <template
                        v-if="itens.length > 0"
                        #afterTable
                    >

                        <div class="text-center table-footer">
                            <span class="mr-4">
                                <strong>Total de Registros:</strong> {{ totalRegistros }}
                            </span>
                            <span class="mr-4">
                                <strong>Total de Procedimentos SIGTAP:</strong> {{ totalProcedimentos }}
                            </span>
                            <span>
                                <strong>Total de Procedimentos ABPG:</strong> {{ totalAbpg }}
                            </span>
                        </div>
                    </template>
            </rkm-table>

        </rkm-area>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, formats, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        totalRegistros() {

            return this.itens.length
        },
        totalProcedimentos() {

            return this.itens.reduce((sum, item) => sum + (item.procedimentosSigtap?.length || 0), 0)
        },
        totalAbpg() {

            return this.itens.reduce((sum, item) => sum + (item.procedimentosAbpg?.length || 0), 0)
        },
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            const hasCodigo = this.selectedCols.includes('ocupacaoCodigo')
            const hasNome = this.selectedCols.includes('ocupacaoNome')
            const cols = []
            let cboInserted = false

            for (const col of this.columns) {
                if (col.key === 'ocupacaoCodigo' || col.key === 'ocupacaoNome') {
                    if ((hasCodigo || hasNome) && !cboInserted) {
                        cols.push({ key: 'cbo', label: 'CBO', sortable: true, class: 'col-min' })
                        cboInserted = true
                    }
                } else if (col.fixed || this.selectedCols.includes(col.key)) {
                    cols.push(col)
                }
            }

            return cols
        },
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableEspecialidade() {

            return !this.isPeriodoSelecionado
                || this.model.ocupacaoId === null
        },
        disableUsuario() {

            return !this.isPeriodoSelecionado
        },
        disableProcedimento() {

            return !this.isPeriodoSelecionado
        },
        disableProcedimentoAbpg() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioProcedimento: this.getConectaSusRepository('ambulatorio.relatorioProcedimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'pacienteNome',
                'pacienteProntuario',
                'unidadeNomeFantasia',
                'especialidadeNome',
                'usuarioNome',
                'procedimentosSigtap',
                'procedimentosSigtapDescricao'
            ],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                { key: 'pacienteNome', label: 'Paciente', sortable: true },
                {
                    key: 'pacienteDataNascimento',
                    label: 'Data de nascimento',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.isNullOrEmptyString(value) ? null : this.formatDate(value),
                    filterByFormatted: true,
                },
                { key: 'pacienteIdade', label: 'Idade', sortable: true },
                { key: 'pacienteProntuario', label: 'Prontuário', sortable: true },
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'ocupacaoCodigo', label: 'CBO Código', sortable: true, class: 'col-min' },
                { key: 'ocupacaoNome', label: 'CBO Nome', sortable: true },
                { key: 'especialidadeNome', label: 'Especialidade', sortable: true },
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
                { key: 'procedimentosSigtap', label: 'Código SIGTAP', sortable: true },
                { key: 'procedimentosSigtapDescricao', label: 'Descrição SIGTAP', sortable: true },
                { key: 'procedimentosAbpg', label: 'Código ABPG', sortable: true },
                { key: 'procedimentosAbpgDescricao', label: 'Descrição ABPG', sortable: true },

            ],
            itens: [],
            sortBy: 'data',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        cboText(item) {

            const hasCodigo = this.selectedCols.includes('ocupacaoCodigo')
            const hasNome = this.selectedCols.includes('ocupacaoNome')

            if (hasCodigo && hasNome) {
                return [item.ocupacaoNome, item.ocupacaoCodigo].filter(Boolean).join(' - ') || '-'
            }
            if (hasCodigo) return item.ocupacaoCodigo || '-'
            return item.ocupacaoNome || '-'
        },
        load() {

            this.setLoading()

            this.repositories.relatorioProcedimento.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioProcedimento.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))

                    if (this.form.infraestruturas?.length === 1 && this.model.infraestruturaId === null) {

                        this.$set(this.model, 'infraestruturaId', this.form.infraestruturas[0].id)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            field = field === 'procedimento' ? `${field}Codigo` : `${field}Id`

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'ocupacaoId',
                'especialidadeId',
                'usuarioId',
                'procedimentoCodigo',
                'procedimentoAbpgId',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioProcedimento.index(this.prepareData())
                .then(({ data }) => {
                    this.itens = data.procedimentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioProcedimento(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportar() {

            this.setLoading()

            this.repositories.exportacao.relatorioProcedimento(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()
            data.sort_by = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sort_desc = this.sortDesc

            const hasCodigo = this.selectedCols.includes('ocupacaoCodigo')
            const hasNome = this.selectedCols.includes('ocupacaoNome')

            data.columns = this.fields.flatMap(f => {
                if (f.key === 'cbo') {
                    if (hasCodigo && hasNome) return [{ key: 'ocupacao_cbo', label: 'CBO', class: 'col-min' }]
                    if (hasCodigo) return [{ key: 'ocupacao_codigo', label: 'CBO', class: 'col-min' }]
                    if (hasNome) return [{ key: 'ocupacao_nome', label: 'CBO', class: '' }]
                    return []
                }
                return [{ key: this.camelToSnake(f.key), label: f.label, class: f.class }]
            })

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, formats, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
</style>